interface TableSkeletonProps {
  rows?: number;
  columns?: number;
  width?: string | number;
  height?: string | number;
  rowHeight?: string | number;
}

const columnSkeletonStyles = [
  { width: 110, height: 16, borderRadius: 8 }, // columna 1
  { width: 180, height: 16, borderRadius: 8 }, // columna 2
  { width: 278, height: 16, borderRadius: 8 }, // columna 3
  { width: 80, height: 16, borderRadius: 8 }, // columna 4
  { width: 160, height: 16, borderRadius: 8 }, // columna 5
  { width: 120, height: 22, borderRadius: 2 }, // columna 6
  { width: 24, height: 24, borderRadius: 12 }, // columna 7
];

const TableSkeleton = ({
  rows = 10,
  columns = 6,
  width = '100%',
  height = 'auto',
  rowHeight = '56px',
}: TableSkeletonProps) => {
  const skeletonColumns = columnSkeletonStyles.slice(0, columns);

  return (
    <div
      style={{
        width,
        height,
        minHeight: height,
        boxSizing: 'border-box',
      }}
    >
      {[...Array(rows)].map((_, rowIdx) => (
        <div
          key={rowIdx}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-around',
            height: rowHeight,
            minHeight: '36px',
            background: rowIdx === 0 ? '#F5F7FA' : 'transparent',
            borderBottom: '1px solid #DFE6EB',
            boxShadow: 'none',
            margin: 0,
            padding: 0,
          }}
        >
          {skeletonColumns.map((colStyle, colIdx) => (
            <div
              key={colIdx}
              style={{
                width: colStyle.width,
                height: colStyle.height,
                borderRadius: colStyle.borderRadius,
                background: '#e0e0e0',
                animation: 'pulse 1.5s infinite',
                marginRight:
                  colIdx !== columnSkeletonStyles.length - 1 ? 16 : 0,
                boxShadow: 'none',
              }}
            />
          ))}
        </div>
      ))}
      <style>
        {`
        @keyframes pulse {
          0% { opacity: 1; }
          50% { opacity: 0.4; }
          100% { opacity: 1; }
        }
      `}
      </style>
    </div>
  );
};

export default TableSkeleton;
